<div class="full-page">
  <!--  Ignore this if you don't want it to overwrite side-menu/header -->
  <div style="height: 100vh; position: relative">
    <!-- Ignore this if you don't want it to overwrite side-menu/header -->
    <div class="map-container white-box" style="padding-top: 15px">
      <div class="map-inner">
        <div class="d-flex flex-wrap w-100 px-3">
          <div
            class="text-center flex-grow-1 counters"
            [class.greyed]="showingStat != null && showingStat != 0"
            (click)="showOnlyStat(0)"
          >
            <span class="counter">{{ stats(0) }}</span>
            <br />live
          </div>
          <div
            class="text-center flex-grow-1 counters"
            [class.greyed]="showingStat != null && showingStat != 1"
            (click)="showOnlyStat(1)"
          >
            <span class="counter">{{ stats(1) }}</span>
            <br />completed
          </div>
          <div
            class="text-center flex-grow-1 counters"
            [class.greyed]="showingStat != null && showingStat != 2"
            (click)="showOnlyStat(2)"
          >
            <span class="counter">{{ stats(2) }}</span
            ><br />pending
          </div>
          <div
            class="text-center flex-grow-1 counters"
            [class.greyed]="showingStat != null && showingStat != 5"
            (click)="showOnlyStat(5)"
          >
            <span class="counter">{{ stats(5) }}</span
            ><br />paused
          </div>
          <div
            class="text-center flex-grow-1 counters"
            [class.greyed]="showingStat != null && showingStat != 4"
            (click)="showOnlyStat(4)"
          >
            <span class="counter text-danger">{{ stats(4) }}</span
            ><br />alerts
          </div>
        </div>

        <div class="under-box">
          <div class="flex w-100 grid-gap-5">
            <div style="position: relative" class="flex-grow-1">
              <div style="position: absolute; top: 0; left: 10px; color: #aaa; line-height: 28px">
                <i class="fa fa-search"></i>
              </div>
              <input
                [(ngModel)]="filterText"
                (keyup)="markerSearch($event, this.filterText)"
                pInputText
                style="
                  border-radius: 3px;
                  height: 28px;
                  border-bottom: none;
                  background-image: none;
                  width: 100%;
                  padding-left: 30px;
                  background-color: #fff;
                "
              />
              <div
                (click)="clearSearch()"
                style="
                  position: absolute;
                  top: 0;
                  right: 5px;
                  color: #888;
                  line-height: 28px;
                  cursor: pointer;
                "
              >
                <i class="fa fa-times"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-box" *ngIf="filterText.length > 1" style="">
          <div *ngIf="noSearchResults()" class="p-3">No search results</div>

          <table class="search-table">
            <!-- Cars -->
            <tr
              *ngFor="let mapMarker of markerResults[0] ?? []"
              class="search-result-item"
              (click)="isolateTask(mapMarker)"
            >
              <td class="icon-cell"><i class="la la-car-side"></i></td>
              <td class="content-cell">
                <span class="vrm">{{ mapMarker.task?.vehicle?.registrationNumber }}</span>
                {{ mapMarker.task?.pickupLocation?.postcode }} <i class="fa fa-caret-right"></i>
                {{ mapMarker.task?.dropoffLocation?.postcode }}
              </td>
            </tr>

            <!-- Suppliers -->
            <tr
              *ngFor="let mapMarker of markerResults[1] ?? []"
              class="search-result-item"
              (click)="isolateTask(mapMarker)"
            >
              <td class="icon-cell"><i class="la la-user"></i></td>
              <td class="content-cell supplier-cell">
                <div>{{ mapMarker.task?.order?.job?.supplier?.name }}</div>
                <div class="driver">
                  {{ mapMarker.task?.driver?.firstName }} {{ mapMarker.task?.driver?.surname }}
                  <span class="vrm">{{ mapMarker.task?.vehicle?.registrationNumber }}</span>
                </div>
              </td>
            </tr>

            <!-- Locations -->
            <tr
              *ngFor="let mapMarker of markerResults[2] ?? []"
              class="search-result-item"
              (click)="isolateTask(mapMarker)"
            >
              <td class="icon-cell"><i class="la la-map-marker"></i></td>
              <td class="content-cell">
                {{ mapMarker.task?.pickupLocation?.postcode }} <i class="fa fa-caret-right"></i>
                {{ mapMarker.task?.dropoffLocation?.postcode }}
                <span class="vrm">{{ mapMarker.task?.vehicle?.registrationNumber }}</span>
              </td>
            </tr>

            <!-- Jobs -->
            <tr
              *ngFor="let mapMarker of markerResults[3] ?? []"
              class="search-result-item"
              (click)="isolateTask(mapMarker)"
            >
              <td class="icon-cell"><i class="fa fa-ticket"></i></td>
              <td class="content-cell">{{ mapMarker.task?.order.job.jobNumber }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="top-right flex grid-gap-10">
      <div class="flex white-box grid-gap-5" style="padding: 4px 5px 4px 8px">
        <div
          class="flex-grow-1"
          *ngIf="!timeInput"
          (click)="displayModeChanged()"
          style="line-height: 28px"
        >
          {{ timeNow | date : 'HH:mm' }}
        </div>
        <div
          class="flex-grow-1"
          [@openClose]="timeInput"
          style="overflow-x: hidden; overflow-y: hidden"
        >
          <div class="flex" *ngIf="timeInput">
            <div
              *ngIf="displayMode != DisplayMode.Live"
              (click)="displayModeChanged()"
              class="flex-shrink-1 pt-1 pr-1"
            >
              <span style="">{{ timePreview | hourDecimalToHHMM : 1 }}</span>
            </div>
            <div class="flex-grow-1">
              <div
                style="
                  padding-top: 13px;
                  padding-left: 12px;
                  padding-right: 5px;
                  width: 100%;
                  box-sizing: border-box;
                "
              >
                <p-slider
                  [style]="{ width: '125px' }"
                  [(ngModel)]="timePreview"
                  (onChange)="timeOffsetSubject.next($event.value)"
                  [min]="8"
                  [max]="20"
                  [step]="0.018"
                  [styleClass]="'time-slider'"
                ></p-slider>
              </div>
            </div>
          </div>
        </div>

        <div
          class="time-option time-option-{{ displayMode }}"
          [style]="{ width: displayMode == DisplayMode.Live ? '50px' : '100px' }"
          (click)="displayModeChanged()"
        >
          {{ displayModeName(displayMode) }}
        </div>
      </div>

      <div (click)="goBack()" class="white-box">
        <div class="p-2">
          <i class="la la-times"></i>
        </div>
      </div>
    </div>

    <div class="legend-container">
      <div *ngIf="showHomesFilter" style="overflow-x: hidden; overflow-y: hidden">
        <div class="text-right white-box" style="display: inline-block; padding: 7px 0 2px 8px">
          <div>
            <div class="legend-item" (click)="toggleHomes(4)" [class.greyed]="!showHomes[4]">
              <span style="color: #06b7e3"><i class="fa fa-home"></i></span>
              Has Tasks
            </div>
            <div class="legend-item" (click)="toggleHomes(1)" [class.greyed]="!showHomes[1]">
              <span style="color: #04aa6d"><i class="fa fa-home"></i></span>
              Available
            </div>
            <div class="legend-item" (click)="toggleHomes(2)" [class.greyed]="!showHomes[2]">
              <span style="color: #e34d06"><i class="fa fa-home"></i></span>
              Unavailable
            </div>
            <div class="legend-item" (click)="toggleHomes(3)" [class.greyed]="!showHomes[3]">
              <span style="color: #e3af06"><i class="fa fa-home"></i></span>
              Unknown
            </div>
          </div>
        </div>
        <div class="home-caret">
          <i class="fa fa-caret-down" style="color: #fff"></i>
        </div>
      </div>

      <div class="white-box" style="padding: 7px 0px 2px 8px">
        <div class="legend-item" (click)="toggleFilter(0)" [class.greyed]="!inFilterList(0)">
          <img
            src="assets/images/svg/car-top-view-grey.svg"
            class="legend-image"
            alt="Legend Image"
          />
          Pending
        </div>

        <div class="legend-item" (click)="toggleFilter(5)" [class.greyed]="!inFilterList(5)">
          <img
            alt="Legend Image"
            src="assets/images/svg/car-top-view-parked-no-border.svg"
            class="legend-image"
            style="vertical-align: inherit"
          />
          Paused
        </div>

        <div class="legend-item" (click)="toggleFilter(1)" [class.greyed]="!inFilterList(1)">
          <img
            src="assets/images/svg/car-top-view-purple.svg"
            class="legend-image"
            alt="Legend Image"
          />
          Heading To Collection
        </div>

        <div class="legend-item" (click)="toggleFilter(2)" [class.greyed]="!inFilterList(2)">
          <img
            src="assets/images/svg/car-top-view-blue.svg"
            class="legend-image"
            alt="Legend Image"
          />
          Heading to Dropoff
        </div>

        <div class="legend-item" (click)="toggleFilter(3)" [class.greyed]="!inFilterList(3)">
          <span style="color: #04aa6d"><i class="fa fa-check-circle"></i></span>
          Job Complete
        </div>

        <div class="legend-item" (click)="toggleFilter(4)" [class.greyed]="!inFilterList(4)">
          <span style="color: #c00"><i class="fa fa-exclamation-triangle"></i></span>
          Alert
        </div>

        <div class="legend-item" (click)="toggleFilter(6)" [class.greyed]="!inFilterList(6)">
          <span style="color: #626262"><i class="fa fa-home"></i></span>
          Home
        </div>
      </div>
    </div>

    <div
      class="marker-popup"
      cdkDrag
      [cdkDragFreeDragPosition]="dragPosition"
      [style.top]="cursorTop"
      [style.left]="cursorLeft"
      [style.display]="showSupplierPopup || showTaskPopup ? 'block' : 'none'"
    >
      <div class="pt-2" *ngIf="showSupplierPopup">
        <div class="px-2 pb-1">
          <div class="flex">
            <div class="flex-grow-1">
              <strong>Supplier Info</strong>
            </div>
            <div class="flex-shrink-1 close-icon" (click)="showSupplierPopup = !showSupplierPopup">
              <span>
                <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
          <div class="supplier-info">
            <i class="fa fa-user"></i>&nbsp;{{ currentSupplierMarker?.supplierHome?.supplierName }}
          </div>
          <div class="supplier-info">
            <i class="fa fa-phone"></i>&nbsp;<a
              href="tel:{{ currentSupplierMarker?.supplierHome?.supplierPhone"
              >{{ currentSupplierMarker?.supplierHome?.supplierPhone }}</a
            >
          </div>
          <div class="supplier-info">
            <i class="fa fa-envelope"></i>&nbsp;<a
              href="mailto:{{ currentSupplierMarker?.supplierHome?.supplierEmail"
              >{{ currentSupplierMarker?.supplierHome?.supplierEmail }}</a
            >
          </div>
          <div>
            <span
              class="available available-{{ currentSupplierMarker?.supplierHome?.available }}"
              >{{ availableLabel(currentSupplierMarker) }}</span
            >
          </div>
        </div>
        <div
          class="supplier-info mt-1 px-2 pb-1 pt-1"
          *ngIf="currentSupplierTasks.length > 0"
          style="background-color: #eee; border-radius: 0 0 5px 5px"
        >
          <div style="font-weight: 600">Tasks Today</div>
          <div *ngFor="let marker of currentSupplierTasks">
            <table style="width: 100%">
              <tbody>
                <tr>
                  <td>
                    {{ taskPickupTime(marker) | datex : 'ddd HH:mm' }}
                    -
                    {{ taskDropoffTime(marker) | datex : 'ddd HH:mm' }}
                  </td>
                  <td>
                    {{ marker.task?.pickupLocation?.postcode }}
                    <i class="fa fa-caret-right"></i>
                    {{ marker.task?.dropoffLocation?.postcode }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div *ngIf="showTaskPopup">
        <div class="px-2 pt-2 pb-1">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div>
                <strong>{{ currentMarker?.task?.order?.job?.jobNumber }}</strong>
              </div>
            </div>
            <div class="flex-shrink-1">
              <span class="vrm">
                {{ currentMarker?.task?.vehicle?.registrationNumber }}
              </span>
            </div>
            <div class="flex-shrink-1 close-icon" (click)="closePopup()">
              <span>
                <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
          <div class="make-model">
            {{ currentMarker?.task?.vehicle?.make }}
            {{ currentMarker?.task?.vehicle?.model }}
          </div>
        </div>
        <div class="attention" *ngIf="displayMode == DisplayMode.Historical">
          <span *ngIf="locationTime(this.plotDateTime, currentMarker?.task?.id); else noPing">
            Pinged location at
            {{ locationTime(this.plotDateTime, currentMarker?.task?.id) | date : 'HH:mm' }}
          </span>
          <ng-template #noPing>
            No data received before {{ this.plotDateTime | date : 'HH:mm' }}
          </ng-template>
        </div>
        <div class="attention" *ngIf="displayMode == DisplayMode.Predictive">
          Predicted location at
          {{ (locationTime(this.plotDateTime, currentMarker?.task?.id) | date : 'HH:mm') || 'N/A' }}
        </div>
        <div *ngFor="let incident of activeIncidents(currentMarker)">
          <div class="incident px-2 py-1">
            <i class="fa fa-exclamation-triangle"></i>
            {{ incident.opened | date : 'HH:mm' }}: {{ incident.typeName }} -
            {{ incident.comment }}
          </div>
        </div>
        <div style="width: 100%; height: 150px">
          <map-control
            [styleClass]="'full-height'"
            [alwaysAutofit]="true"
            [overlays]="[currentMarker]"
            [tasks]="[currentMarker.task]"
            *ngIf="currentMarker != null"
          ></map-control>
        </div>
        <div class="lower-pane">
          <div class="p-2">
            <div class="mb-1 pick-up-color">
              <span class="legend-icon"><i class="fa fa-arrow-up"></i></span>
              {{ taskPickupTime(currentMarker) | datex : 'HH:mm' }}
              {{ currentMarker?.task?.pickupLocation?.city }},
              {{ currentMarker?.task?.pickupLocation?.postcode }}
            </div>
            <div class="mb-1 drop-off-color">
              <span class="legend-icon"><i class="fa fa-arrow-down"></i></span>
              {{ taskDropoffTime(currentMarker) | datex : 'HH:mm' }}
              {{ currentMarker?.task?.dropoffLocation?.city }},
              {{ currentMarker?.task?.dropoffLocation?.postcode }}
            </div>
            <div class="mb-1">
              <span class="legend-icon"><i class="fa fa-building"></i></span>
              {{ currentMarker?.task?.order?.customer?.name }}
            </div>
          </div>
          <div
            *ngIf="currentMarker?.task?.lastTaskTracking != null"
            class="p-2"
            [class.late-warning]="showETA && taskETA?.lateWarning && !fetchingETA"
            style="
              border-top: 1px solid var(--linkColor);
              border-bottom: 1px solid var(--linkColor);
              background-color: #d9edf9;
              font-size: 12px;
            "
          >
            <div class="d-flex flex-wrap">
              <div class="flex-grow-1" *ngIf="showETA">
                ETA:
                <span *ngIf="fetchingETA"><i class="fa fa-spin fa-spinner"></i></span>
                <span *ngIf="!fetchingETA">{{ taskETA?.eta | datex : 'HH:mm' }}</span>
              </div>
              <div class="flex-grow-1" *ngIf="showETA">
                Distance:
                <span *ngIf="fetchingETA"><i class="fa fa-spin fa-spinner"></i></span>
                <span *ngIf="!fetchingETA">{{ taskETA?.distance | toMiles }} miles</span>
              </div>
              <div class="flex-grow-1 text-center">
                <i class="fa fa-compass"></i>
                {{ directionWords(currentMarker?.task?.lastTaskTracking?.heading) }}
                {{ currentMarker?.task?.lastTaskTracking?.speed | number : '1.0-0' }} mph
              </div>
            </div>
          </div>
          <div
            style="background-color: #f0f0f0"
            class="p-2 cursor-pointer"
            (click)="viewSupplier(currentMarker?.task?.order?.job.supplier?.id)"
          >
            <div class="mb-1 link-style">
              <span class="legend-icon"><i class="fa fa-truck"></i></span>
              {{ currentMarker?.task?.order?.job?.supplier?.name }}
            </div>
            <div class="mb-1">
              <span class="legend-icon"><i class="fa fa-user"></i></span>
              {{ currentMarker?.task?.driver?.firstName }}
              {{ currentMarker?.task?.driver?.surname }}
            </div>
            <div class="mb-1">
              <div class="d-flex">
                <div (click)="callDriver($event, currentMarker)" class="link-style cursor-pointer">
                  <span class="legend-icon"><i class="fa fa-phone"></i></span>
                  {{ currentMarker?.task?.driver?.mobileNumber || 'N/A' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="text-center bottom-strip cursor-pointer"
          (click)="viewJob($event, currentMarker?.task?.order?.job?.id)"
          title="Task {{ currentMarker?.task?.id }}"
        >
          View Job
        </div>
      </div>
    </div>

    <div style="z-index: 99; height: 100%; background-color: black; cursor: pointer">
      <map-control
        [readOnly]="true"
        [styleClass]="'full-height'"
        (overlayClick)="overClickEvent($event)"
        [panTo]="panTo"
        [zoom]="zoomLevel"
        [overlays]="overlayPoints"
        (zoomChange)="zoomChanged($event)"
      >
      </map-control>
    </div>
  </div>
</div>
